export default __webpack_public_path__ + "static/media/ipr.c6e03c81.svg";